import SupportPage from "./supportPage/SupportPage";
import SupportCategory from "./supportCategory/SupportCategory";
import SupportTickets from "./supportTicket/SupportTicket";
import { usePageSection } from "../../navigation/pageSections";

// Support / Tickets / Categories are opened from the sidebar submenu (`?tab=`).
// Categories need support.category.manage; without it the page falls back to Support.
const Support = () => {
  const [activeTab] = usePageSection("support");
  return (
    <div className={`support-page-container`}>
      {activeTab === "support" && <SupportPage />}

      {activeTab === "tickets" && <SupportTickets />}
      {activeTab === "category" && <SupportCategory />}
    </div>
  );
};

export default Support;
